import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-between gap-4 min-h-15 md:max-w-[295px]" }
const _hoisted_2 = {
  tabindex: "0",
  class: "shadow-lg cursor-grab bg-white rounded-md border-2 border-gray-200 flex items-center p-2 px-3 justify-between w-full"
}
const _hoisted_3 = { class: "text-sm truncate mr-3" }
const _hoisted_4 = { class: "truncate text-sm font-medium text-gray-800" }

import { 
		useI18n
	} from 'vue-i18n'

	// Store
	import {
		useSceneEditorStore
	} from '@/store/sceneEditor'

	// Vue
	

	
	const __default__ = { name: 'AvailableSceneCard' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		loading: {
			type: Boolean,
			default: false
		},
		scene: {
			type: Object,
			default: () => {return {}}
		}
	},
  emits: ['closeModal'],
  setup(__props, { emit: __emit }) {

	// Languages
	const props = __props

	const emit = __emit

	const {t} = useI18n()
	const sceneEditorStore = useSceneEditorStore()

	/**
	 * Adds scene to scene editor store and closes modal
	 * @function addScene
	 */
	function addScene() {
		const scene = {
			recordId: props.scene.recordId,
			"job__job_scene__SCENES__sceneID::name_display": props.scene['jobs__contacts_scenes__SCENES__sceneID::name_display'],
			"job__JOBS_SCENES__jobID::scene_number": sceneEditorStore.sceneEditor.scenes.length,
			"job__JOBS_SCENES__jobID::main_scene": props.scene['jobs__CONTACTS_SCENES__serviceID::main_scene'],
			"job__JOBS_SCENES__jobID::standard": props.scene['jobs__CONTACTS_SCENES__serviceID::standard'],
			"job__JOBS_SCENES__jobID::_kf_jobs_id": props.scene['JOBS::_kp_jobs_id'],
			"job__job_scene__job_song__SONGS__songID::name_display": '',
			"job__JOBS_SCENES__jobID::_kp_jobs_scenes_id": '',
			"job__JOBS_SCENES__jobID::_kf_contacts_scenes_id": props.scene['jobs__CONTACTS_SCENES__serviceID::_kp_contacts_scenes_id'],
			"job__JOBS_SCENES__jobID::_kf_scenes_id": props.scene['jobs__CONTACTS_SCENES__serviceID::_kf_scenes_id'],
			modId: props.scene.modId
		}

		sceneEditorStore.sceneEditor.scenes.push(scene)
		emit('closeModal')
	}


return (_ctx: any,_cache: any) => {
  const _component_StarIconMini = _resolveComponent("StarIconMini")!
  const _component_tw_button = _resolveComponent("tw-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(__props.scene['jobs__contacts_scenes__SCENES__sceneID::name_display']), 1)
      ]),
      (Boolean(__props.scene['jobs__CONTACTS_SCENES__serviceID::main_scene']))
        ? (_openBlock(), _createBlock(_component_StarIconMini, {
            key: 0,
            class: "h-4 w-4 text-brand-500"
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_tw_button, {
      onClick: addScene,
      class: "flex-none btn-brand md:hidden"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" + " + _toDisplayString(_unref(t)('sceneEditor.add')), 1)
      ]),
      _: 1
    })
  ]))
}
}

})